import { Loader2 } from "lucide-react";
import { useSiteForm } from "@/lib/site";
import { Reveal } from "./Reveal";
import { Field, Honeypot, FormError } from "./Field";

const WaitlistSuccess = ({ name, email }) => (
  <div data-testid="waitlist-success" role="status" className="py-6 text-center">
    <p className="cl-heading text-3xl text-[#E6EDF4] sm:text-4xl">
      You're on the list <span className="text-[#E7C99D]">✦</span>
    </p>
    <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-[#9AAABD]">
      Thank you, <span data-testid="waitlist-success-name" className="text-[#E6EDF4]">{name}</span>, we'll be in touch at{" "}
      <span data-testid="waitlist-success-email" className="text-[#E7C99D]">{email}</span> the moment we launch.
    </p>
  </div>
);

const WaitlistForm = () => {
  const f = useSiteForm({ initial: { name: "", email: "", phone: "" }, rules: ["name", "email", "phone"], endpoint: "/site/waitlist" });
  if (f.status === "success") return <WaitlistSuccess name={f.result.name} email={f.result.email} />;
  const loading = f.status === "loading";
  return (
    <form onSubmit={f.submit} noValidate data-testid="waitlist-form" className="relative flex flex-col gap-5">
      <Field id="wl-name" name="name" label="Full name" autoComplete="name" placeholder="Your full name" value={f.values.name} onChange={f.onChange} error={f.errors.name} testid="waitlist-name-input" />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field id="wl-email" name="email" type="email" label="Email" autoComplete="email" placeholder="you@family.com" value={f.values.email} onChange={f.onChange} error={f.errors.email} testid="waitlist-email-input" />
        <Field id="wl-phone" name="phone" type="tel" label="Phone number" autoComplete="tel" placeholder="+971 50 123 4567" value={f.values.phone} onChange={f.onChange} error={f.errors.phone} testid="waitlist-phone-input" />
      </div>
      <Honeypot value={f.honeypot} onChange={f.setHoneypot} testid="waitlist-honeypot" />
      <FormError message={f.formError} testid="waitlist-form-error" />
      <button type="submit" disabled={loading} data-testid="waitlist-submit-button" className="btn-solid mt-2 w-full">
        {loading ? <><Loader2 size={16} className="animate-spin" /> Joining…</> : "Join the waitlist"}
      </button>
    </form>
  );
};

export const LaunchingSoon = () => (
  <section id="launching-soon" data-testid="section-launching-soon" className="cl-section relative overflow-hidden">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[900px] max-w-[160vw] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_at_center,rgba(231,201,157,0.07)_0%,transparent_65%)]" />
    <div className="cl-container relative">
      <Reveal className="mx-auto max-w-2xl text-center">
        <span data-testid="launching-badge" className="inline-flex items-center gap-2 rounded-full border border-[#E7C99D]/50 bg-[#E7C99D]/10 px-4 py-1.5 text-[11px] font-medium tracking-[0.28em] text-[#E7C99D]">
          ✦ LAUNCHING SOON
        </span>
        <h2 className="cl-heading mt-7 text-4xl text-[#E6EDF4] sm:text-[3.4rem]">Be first through the door</h2>
        <p className="mt-6 text-base leading-relaxed text-[#9AAABD] sm:text-lg">
          Chronoloop is coming to iOS and Android. Join the waitlist and we'll tell you the moment it's ready — with
          early-access perks for our founding families.
        </p>
      </Reveal>
      <Reveal delay={150} id="waitlist-card" className="cl-card mx-auto mt-14 max-w-2xl p-6 sm:p-10">
        <WaitlistForm />
      </Reveal>
    </div>
  </section>
);
